import { Grid, TextField, TextareaAutosize } from "@mui/material";
import { Controller } from "react-hook-form";
import FieldError from "shared/organisms/dynamicform/FieldError";

const AddressField = ({ field, control, errors }) => {
  return (
    <Grid item {...field.breakpoints}>
      <Controller
        render={({ field: { onChange, value } }) => (
          <TextareaAutosize
            aria-label="minimum height"
            minRows={3}
            onChange={onChange}
            required={field.required}
            value={value}
            placeholder={field.label}
            style={{
              width: "50%",
              resize: "none",
              border: "1px solid #c4c4c4",
              borderRadius: "4px",
              fontSize: "16px",
            }}
            className={field.className}
          />
        )}
        name={field.id}
        control={control}
        defaultValue=""
      />
      {errors && errors[field.id]?.message && (
        <FieldError field={field} errors={errors} />
      )}
    </Grid>
  );
};

export default AddressField;
